import React from 'react';

const CV = () => (
  <svg
    version="1.1"
    id="cv"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <path
        className="semiCircle"
        fill="#27AE60"
        d="M12,1c6.075,0,11,4.925,11,11s-4.925,11-11,11S1,18.075,1,12S5.925,1,12,1"
      />
      <path
        fill="#FCFCFC"
        d="M19.063,8.07c-0.15,0-0.279,0.039-0.387,0.117c-0.108,0.078-0.183,0.177-0.225,0.297l-1.818,4.933
            c-0.103,0.288-0.189,0.569-0.262,0.846s-0.138,0.552-0.198,0.828c-0.054-0.276-0.116-0.552-0.188-0.828
            c-0.071-0.276-0.156-0.558-0.252-0.846L13.95,8.484c-0.035-0.12-0.109-0.219-0.22-0.297c-0.111-0.078-0.251-0.117-0.419-0.117
            h-1.836l3.663,9.234h2.016l3.663-9.234H19.063 M11.017,9.214C10.603,8.8,10.136,8.481,9.617,8.26S8.494,7.927,7.804,7.927
            c-0.726,0-1.368,0.12-1.926,0.36C5.32,8.526,4.852,8.858,4.474,9.281s-0.665,0.924-0.859,1.503s-0.292,1.208-0.292,1.886
            c0,0.756,0.109,1.43,0.329,2.021c0.219,0.591,0.518,1.09,0.896,1.498s0.819,0.719,1.323,0.932s1.041,0.319,1.611,0.319
            c0.324,0,0.649-0.023,0.976-0.071c0.327-0.049,0.645-0.131,0.954-0.248s0.607-0.272,0.896-0.468s0.555-0.437,0.801-0.725
            l-0.639-0.81c-0.09-0.139-0.225-0.207-0.405-0.207c-0.138,0-0.263,0.043-0.374,0.13c-0.111,0.087-0.242,0.184-0.392,0.288
            c-0.15,0.105-0.334,0.201-0.554,0.288c-0.219,0.087-0.505,0.131-0.859,0.131s-0.672-0.067-0.954-0.203
            c-0.282-0.135-0.522-0.333-0.72-0.594c-0.198-0.261-0.35-0.583-0.455-0.968C5.651,13.6,5.599,13.162,5.599,12.67
            c0-0.475,0.048-0.898,0.144-1.273s0.242-0.694,0.437-0.959c0.195-0.264,0.439-0.466,0.733-0.607
            c0.294-0.141,0.636-0.211,1.026-0.211c0.306,0,0.563,0.034,0.769,0.104c0.207,0.068,0.386,0.146,0.536,0.233
            s0.279,0.165,0.387,0.234c0.108,0.068,0.219,0.104,0.333,0.104c0.12,0,0.211-0.024,0.274-0.072l0.193-0.198L11.017,9.214"
      />
      <path
        fill="#E9E8E8"
        d="M7.375,21.983c1.401,0.65,2.962,1.014,4.607,1.017C10.336,22.997,8.775,22.634,7.375,21.983 M22.647,9.229
            C22.878,10.114,23,11.042,23,12c0,0,0,0,0,0C23,11.042,22.878,10.114,22.647,9.229 M19.778,4.221L19.778,4.221
            c0.826,0.827,1.521,1.784,2.053,2.838C21.3,6.005,20.604,5.048,19.778,4.221"
      />
      <path
        className="semiCircle"
        fill="#27AE60"
        d="M19.778,4.221l-5.412,5.413l1.366,3.783c0.096,0.288,0.181,0.569,0.252,0.846
            c0.072,0.276,0.135,0.552,0.188,0.828c0.061-0.276,0.126-0.552,0.198-0.828s0.159-0.558,0.262-0.846l1.818-4.933
            c0.042-0.12,0.116-0.219,0.225-0.297c0.107-0.078,0.236-0.117,0.387-0.117h1.755l-3.663,9.234h-2.016l-2.398-6.046l-4.469,4.469
            c0.183-0.021,0.34-0.058,0.473-0.11c0.219-0.087,0.403-0.183,0.554-0.288c0.15-0.104,0.28-0.201,0.392-0.288
            c0.111-0.087,0.235-0.13,0.374-0.13c0.18,0,0.315,0.068,0.405,0.207l0.639,0.81c-0.246,0.288-0.513,0.529-0.801,0.725
            S9.719,17.003,9.41,17.12s-0.627,0.199-0.954,0.248c-0.327,0.048-0.652,0.071-0.976,0.071c-0.288,0-0.568-0.027-0.839-0.081
            l-2.419,2.419c0.908,0.908,1.974,1.658,3.153,2.206c1.401,0.65,2.961,1.014,4.607,1.017c0.006,0,0.012,0,0.019,0
            c6.075,0,11-4.926,11-11c0-0.957-0.122-1.885-0.353-2.771c-0.196-0.758-0.472-1.484-0.816-2.169
            C21.3,6.005,20.604,5.048,19.778,4.221"
      />
      <path
        fill="#E6E5E6"
        d="M10.063,14.911c-0.138,0-0.263,0.043-0.374,0.13c-0.111,0.087-0.242,0.184-0.392,0.288
            c-0.15,0.105-0.334,0.201-0.554,0.288c-0.133,0.053-0.29,0.09-0.473,0.11l-1.63,1.631c0.271,0.054,0.551,0.081,0.839,0.081
            c0.324,0,0.649-0.023,0.976-0.071c0.327-0.049,0.645-0.131,0.954-0.248s0.607-0.272,0.896-0.468s0.555-0.437,0.801-0.725
            l-0.639-0.81C10.378,14.979,10.243,14.911,10.063,14.911 M20.817,8.07h-1.755c-0.15,0-0.279,0.039-0.387,0.117
            c-0.108,0.078-0.183,0.177-0.225,0.297l-1.818,4.933c-0.103,0.288-0.189,0.569-0.262,0.846s-0.138,0.552-0.198,0.828
            c-0.054-0.276-0.116-0.552-0.188-0.828c-0.071-0.276-0.156-0.558-0.252-0.846l-1.366-3.783l-1.626,1.625l2.398,6.046h2.016
            L20.817,8.07"
      />
    </g>
  </svg>
);

export default CV;
